import EtcModule from '@features/ETC/Etc.Module';

const Etcs = () => {
  return <EtcModule />;
};

export default Etcs;
